import Decimal from 'decimal.js';
import * as genericFormatNumber from 'helpers/formatNumber';

export default function formatNumber(number, unit) {
  return genericFormatNumber.default(number, unit, 2, Decimal.ROUND_HALF_UP);
}
